export default __webpack_public_path__ + "static/media/ConnectModels.fc95e218.svg";